import UsersApiService from './_services/users.api.service';

import { ActionTypes, MutationTypes } from './store.types';

export { namespace } from './store.types';

export default {
  namespaced: true,
  state: {
    user: {},
    users: [],
    userHistory: [],
    usersNamesAutocomplete: [],
    usersEmailsAutocomplete: [],
  },
  mutations: {
    [MutationTypes.SET_USER](state, payload) {
      state.user = payload;
    },
    [MutationTypes.SET_USERS](state, payload) {
      state.users = payload;
    },
    [MutationTypes.SET_USER_HISTORY](state, payload) {
      state.userHistory = payload;
    },
    [MutationTypes.SET_USERS_NAMES_AUTOCOMPLETE](state, payload) {
      state.usersNamesAutocomplete = payload;
    },
    [MutationTypes.SET_USERS_EMAILS_AUTOCOMPLETE](state, payload) {
      state.usersEmailsAutocomplete = payload;
    },
  },
  actions: {
    async [ActionTypes.GET_USER]({ commit }, { id }) {
      commit(
        MutationTypes.SET_USER,
        await UsersApiService.getUser({ id }),
      );
    },
    async [ActionTypes.GET_USERS]({ commit }, { pageNum, ...rest }) {
      commit(
        MutationTypes.SET_USERS,
        await UsersApiService.getUsers({ pageNum, ...rest }),
      );
    },
    async [ActionTypes.GET_USER_HISTORY]({ commit }, { id, pageNum }) {
      commit(
        MutationTypes.SET_USER_HISTORY,
        await UsersApiService.getUserHistory({ id, pageNum }),
      );
    },
    async [ActionTypes.GET_USERS_NAMES_AUTOCOMPLETE]({ commit }, name) {
      commit(
        MutationTypes.SET_USERS_NAMES_AUTOCOMPLETE,
        await UsersApiService.getUsersNamesAutocomplete({ name }),
      );
    },
    async [ActionTypes.GET_USERS_EMAILS_AUTOCOMPLETE]({ commit }, email) {
      commit(
        MutationTypes.SET_USERS_EMAILS_AUTOCOMPLETE,
        await UsersApiService.getUsersEmailsAutocomplete({ email }),
      );
    },
  },
};
